<template>
  <div class="certificates">
    <CustomTabs
      class="certificates__tabs tw-mb-4"
      :tab="certificatePageTab"
      :data="certificatePageTabsData"
      label-option="label"
      name-option="code"
      alt
      @change_tab="onCertificatePageTabChange"
    >
      <template #default="{ data: tabItem }">
        <div v-if="tabItem.code === 'certificates'">
          <CustomTable
            title="Сертификаты материалов"
            :rowsData="rows || []"
            :columns="columns"
            :stickyHeader="false"
            :loading="isFetching"
            :custom-body="true"
            :small="true"
          >
            <template #top-right>
              <div style="display: flex; gap: 8px;">
                <q-btn
                  :loading="isFetching"
                  @click="loadCertificates"
                  color="primary"
                  size="sm"
                >
                  <q-icon name="replay" />
                </q-btn>
              </div>
            </template>

            <template #customBody="props">
              <q-tr :key="'cert-' + (props.row.project_material_certificate_id || props.row.material_id)">
                <CustomTableCell align="left" vertical-align="center">
                  <div class="certificates__material">
                    <span class="certificates__material-name">
                      {{ props.row.material_name }}
                    </span>
                  </div>
                </CustomTableCell>

                <CustomTableCell align="center" vertical-align="center">
                  <Clickable
                    v-if="!!props.row.certificate_number"
                    class="certificates__cert-number"
                    @click.stop="() => this.openEditCertificateModal(props.row)">
                    {{ props.row.certificate_number }}
                    <CustomIcon icon="edit" small style="margin-left: 4px;" />
                    <q-tooltip>Редактировать номер сертификата</q-tooltip>
                  </Clickable>
                </CustomTableCell>

                <CustomTableCell align="center" vertical-align="center">
                  <div class="certificates__actions">
                    <Clickable
                      v-if="props.row.document_url"
                      class="certificates__download-link"
                      :link="true"
                      :href="`${fileBaseUrl}${props.row.document_url}`"
                      target="_blank"
                    >
                      Скачать
                    </Clickable>
                    <CustomIcon
                      v-if="!!props.row.project_material_certificate_id"
                      icon="trash"
                      :approve-mode="true"
                      :loading="deleting[props.row.project_material_certificate_id]"
                      :approve="() => this.onDeleteCertificate(props.row)"
                      title="Удалить сертификат"
                    />
                    <Clickable
                      v-else
                      class="certificates__add-link"
                      @click.stop="() => this.openEditCertificateModal(props.row)">
                      Добавить сертификат
                    </Clickable>
                  </div>
                </CustomTableCell>

                <CustomTableCell align="center" vertical-align="center">
                  <span
                    v-if="props.row.date_begin"
                    class="certificates__cert-number"
                  >
                    {{ props.row.date_begin }}
                  </span>
                </CustomTableCell>

                <CustomTableCell align="center" vertical-align="center">
                  <span
                    v-if="props.row.date_end"
                    class="certificates__cert-number"
                  >
                    {{ props.row.date_end }}
                  </span>
                </CustomTableCell>
              </q-tr>
            </template>
          </CustomTable>
        </div>

        <div v-else class="laboratory-acts">
          <CustomTable
            title="Лабораторные акты"
            :rowsData="laboratoryRows || []"
            :columns="laboratoryColumns"
            :stickyHeader="false"
            :loading="laboratoryFetching"
            :custom-body="true"
            :small="true"
          >
            <template #top-right>
              <div class="tw-flex tw-gap-2 tw-items-center">
                <q-btn
                  unelevated
                  no-caps
                  color="primary"
                  size="sm"
                  :disable="!projectId"
                  @click="() => this.openEditLaboratoryModal({})"
                >
                  Добавить лабораторный акт
                </q-btn>
                <q-btn
                  :loading="laboratoryFetching"
                  @click="loadLaboratoryActs"
                  color="primary"
                  size="sm"
                >
                  <q-icon name="replay" />
                </q-btn>
              </div>
            </template>

            <template #customBody="props">
              <q-tr :key="'lab-' + props.row.project_laboratory_act_id">
                <CustomTableCell align="left" vertical-align="center">
                  <div class="certificates__material">
                    <span class="certificates__material-name">
                      {{ props.row.laboratory_act_name }}
                    </span>
                  </div>
                </CustomTableCell>

                <CustomTableCell align="right" vertical-align="center">
                  <span
                    v-if="props.row.level_num != null && props.row.level_num !== ''"
                    class="certificates__lab-cell"
                  >
                    {{ props.row.level_num }}
                  </span>
                </CustomTableCell>

                <CustomTableCell align="left" vertical-align="center">
                  <span class="certificates__lab-cell">
                    {{ props.row.placement_type_name }}
                  </span>
                </CustomTableCell>

                <CustomTableCell align="left" vertical-align="center">
                  <span class="certificates__lab-cell">
                    {{ props.row.work_set_check_group_name }}
                  </span>
                </CustomTableCell>

                <CustomTableCell align="center" vertical-align="center">
                  <div class="certificates__actions">
                    <Clickable
                      v-if="props.row.document_url"
                      class="certificates__download-link"
                      :link="true"
                      :href="`${fileBaseUrl}${props.row.document_url}`"
                      target="_blank"
                    >
                      Скачать
                    </Clickable>
                    <CustomIcon
                      v-if="!!props.row.project_laboratory_act_id"
                      icon="trash"
                      :approve-mode="true"
                      :loading="deletingLaboratory[props.row.project_laboratory_act_id]"
                      :approve="() => this.onDeleteLaboratoryAct(props.row)"
                      title="Удалить лабораторный акт"
                    />
                    <Clickable
                      class="certificates__add-link"
                      @click.stop="() => this.openEditLaboratoryModal(props.row)">
                      Редактировать
                    </Clickable>
                  </div>
                </CustomTableCell>
              </q-tr>
            </template>
          </CustomTable>
        </div>
      </template>
    </CustomTabs>
  </div>
</template>

<script>
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import Clickable from "@/components/common/Clickable";
import CustomIcon from "@/components/common/CustomIcon.vue";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomTabs from "@/components/common/CustomTabs";
import { API_URL, MODAL_NAMES } from "@/constants";
import { useAppStore } from "@/services/store/app";
import {
  deleteProjectLaboratoryAct,
  deleteProjectMaterialCertificate,
  getProjectLaboratoryActs,
  getProjectMaterialCertificates,
  laboratoryActsColumns,
  materialCertificatesColumns,
} from "./services";

const CERTIFICATE_PAGE_TAB_QUERY = "certificate_tab";

export default {
  name: "Certificates",
  props: ["params", "projectId"],
  components: {
    CustomTabs,
    CustomTable,
    CustomTableCell,
    Clickable,
    CustomIcon,
  },
  data() {
    return {
      certificatePageTab: "certificates",
      certificatePageTabsData: [
        { code: "certificates", label: "Сертификаты материалов" },
        { code: "laboratory_acts", label: "Лабораторные акты" },
      ],
      columns: materialCertificatesColumns,
      rows: [],
      isFetching: false,
      deleting: {},
      laboratoryColumns: laboratoryActsColumns,
      laboratoryRows: [],
      laboratoryFetching: false,
      deletingLaboratory: {},
    };
  },
  computed: {
    fileBaseUrl() {
      return API_URL;
    },
  },
  watch: {
    "$route.query": {
      deep: true,
      handler() {
        const val = this.$route.query[CERTIFICATE_PAGE_TAB_QUERY];
        if (this.isValidCertificatePageTab(val) && this.certificatePageTab !== val) {
          this.certificatePageTab = val;
        }
      },
    },
  },
  created() {
    this.applyCertificatePageTabFromRoute();
  },
  methods: {
    isValidCertificatePageTab(code) {
      return this.certificatePageTabsData.some((t) => t.code === code);
    },
    applyCertificatePageTabFromRoute() {
      const raw = this.$route.query[CERTIFICATE_PAGE_TAB_QUERY];
      if (this.isValidCertificatePageTab(raw)) {
        this.certificatePageTab = raw;
      } else {
        this.certificatePageTab = "certificates";
      }
    },
    syncCertificatePageTabToRoute(code) {
      this.$router.replace({
        query: { ...this.$route.query, [CERTIFICATE_PAGE_TAB_QUERY]: code },
      });
    },
    onCertificatePageTabChange(code) {
      this.certificatePageTab = code;
      this.syncCertificatePageTabToRoute(code);
    },
    async loadCertificates() {
      if (!this.projectId) return;
      this.isFetching = true;
      const res = await getProjectMaterialCertificates(this.projectId);
      this.isFetching = false;
      if (!res) return;
      this.rows = Array.isArray(res) ? res : [];
    },
    async loadLaboratoryActs() {
      if (!this.projectId) return;
      this.laboratoryFetching = true;
      const res = await getProjectLaboratoryActs(this.projectId);
      this.laboratoryFetching = false;
      if (!res) return;
      this.laboratoryRows = Array.isArray(res) ? res : [];
    },
    openEditCertificateModal(row) {
      this.showModal(MODAL_NAMES.AddMaterialCertificate, {
        title: "Редактировать сертификат",
        projectId: this.projectId,
        material: row,
        onSubmit: async (r) => {
          if (r?.data) {
            this.rows = r.data;
          } else {
            this.rows = r || [];
          }
        },
      });
    },
    openEditLaboratoryModal(row) {
      this.showModal(MODAL_NAMES.AddLaboratoryAct, {
        title: row?.project_laboratory_act_id
          ? "Редактировать лабораторный акт"
          : "Добавить лабораторный акт",
        projectId: this.projectId,
        params: this.params,
        act: row,
        onSubmit: async (r) => {
          if (r?.data && Array.isArray(r.data)) {
            this.laboratoryRows = r.data;
          } else {
            await this.loadLaboratoryActs();
          }
        },
      });
    },
    async onDeleteCertificate(row) {
      const projectMaterialCertificateId = row.project_material_certificate_id;
      if (!this.projectId || !projectMaterialCertificateId || this.deleting[projectMaterialCertificateId]) return;

      this.deleting[projectMaterialCertificateId] = true;
      const res = await deleteProjectMaterialCertificate(
        this.projectId,
        projectMaterialCertificateId
      );
      this.deleting[projectMaterialCertificateId] = false;
      if (!res) return;
      this.rows = res.data || [];
      this.showSucceedSnackbar();
    },
    async onDeleteLaboratoryAct(row) {
      const id = row.project_laboratory_act_id;
      if (!this.projectId || !id || this.deletingLaboratory[id]) return;

      this.deletingLaboratory[id] = true;
      const res = await deleteProjectLaboratoryAct(this.projectId, id);
      this.deletingLaboratory[id] = false;
      if (!res) return;
      this.laboratoryRows = res.data || [];
      this.showSucceedSnackbar();
    },
  },
  async mounted() {
    if (this.$route.query[CERTIFICATE_PAGE_TAB_QUERY]) {
      this.syncCertificatePageTabToRoute(this.certificatePageTab);
    }
    await this.loadCertificates();
    await this.loadLaboratoryActs();
  },
  setup() {
    const { showModal } = useAppStore();
    const { showSucceedSnackbar } = useCustomSnackbar();
    return { showModal, showSucceedSnackbar };
  },
};
</script>

<style scoped lang="scss">
.certificates {
  &__material {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &__material-name {
    font-size: 13px;
    font-weight: 500;
    color: #111827;
  }

  &__lab-cell {
    font-size: 13px;
    color: #374151;
  }

  &__cert-number {
    display: inline-flex;
    align-items: center;
    padding: 4px 20px;
    border-radius: 999px;
    background: #eff6ff;
    color: #1d4ed8;
    font-size: 12px;
    font-weight: 500;
    border: 1px solid #bfdbfe;
    transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      background: #dbeafe;
      color: #1d4ed8;
      box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.25);
    }
  }

  &__actions {
    display: flex;
    gap: 10px;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  &__download-link {
    font-size: 12px;
    font-weight: 500;
    color: #2563eb;
    text-decoration: underline;

    &:hover {
      color: #1d4ed8;
      text-decoration: none;
    }
  }

  &__add-link {
    font-size: 12px;
    font-weight: 500;
    color: #047857;
    padding: 4px 8px;
    border-radius: 6px;
    background: #ecfdf5;
    border: 1px solid #a7f3d0;

    &:hover {
      background: #d1fae5;
      color: #065f46;
    }
  }
}
</style>
